import { useEffect } from 'react';
import { X } from 'lucide-react';

/* Full-screen viewer for the dashboard screenshots — pinch/scroll to zoom on mobile */
export const ImageLightbox = ({ src, alt, label, onClose }) => {
  useEffect(() => {
    const onKey = (ev) => {
      if (ev.key === 'Escape') onClose();
    };
    document.addEventListener('keydown', onKey);
    const prev = document.body.style.overflow;
    document.body.style.overflow = 'hidden';
    return () => {
      document.removeEventListener('keydown', onKey);
      document.body.style.overflow = prev;
    };
  }, [onClose]);

  if (!src) return null;

  return (
    <div
      className="fixed inset-0 z-[100] bg-[#1F0410]/95 backdrop-blur-sm flex flex-col"
      onClick={onClose}
      data-testid="image-lightbox"
    >
      <div className="flex items-center justify-between px-4 py-4 shrink-0">
        <span
          className="font-sans text-[11px] md:text-[13px] uppercase tracking-[0.18em] text-[#E0C07A]"
          style={{ fontWeight: 700 }}
        >
          {label}
        </span>
        <button
          onClick={onClose}
          className="text-[#F5F0E8]/70 hover:text-[#E0C07A] p-2 transition-colors duration-200"
          aria-label="Close image"
          data-testid="lightbox-close"
        >
          <X className="w-6 h-6" strokeWidth={2} />
        </button>
      </div>

      <div className="flex-1 overflow-auto px-3 pb-6 flex items-start justify-start md:items-center md:justify-center">
        <img
          src={src}
          alt={alt}
          onClick={(ev) => ev.stopPropagation()}
          className="max-w-none w-[180%] sm:w-[130%] md:w-auto md:max-w-full md:max-h-full rounded-[12px] shrink-0 m-auto"
          data-testid="lightbox-image"
        />
      </div>

      <p className="text-center font-sans text-[11px] text-[#F5F0E8]/38 pb-5 px-4 shrink-0">
        Pinch to zoom · tap anywhere to close
      </p>
    </div>
  );
};
